import React, { Component, useState, Suspense } from 'react';
import { HashRouter, BrowserRouter as Router, Switch, Route, Redirect, useParams, useRouteMatch } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';


import Header from "./components/Header";
import FixedFooter from "./components/FixedFooter";
import Home from "./components/Home";
import About from "./components/About";
import Experience from "./components/Experience";
import Works from "./components/Works";
import Contact from "./components/Contact";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  render() {
    const { location } = this.props;
    return (
      <div className="App">
        <Header location={location}></Header>
        <HashRouter>
          <Route render={(location) => {
            // console.log(location.location);
            const { pathname, key } = location.location;
            return (
              // <TransitionGroup component={null}>
              //   <CSSTransition key={key} timeout={500} mountOnEnter={false} unmountOnExit={true} classNames="slide-in">
              <Switch>
                <Route path="/contact" render={routeProps => <Contact {...routeProps} />} />
                <Route path="/works" render={routeProps => <Works {...routeProps} />} />
                <Route path="/experience" render={routeProps => <Experience {...routeProps} />} />
                <Route path="/about" render={routeProps => <About {...routeProps} />} />
                <Route path="/" render={routeProps => <Home {...routeProps} />} />
              </Switch>
              //   </CSSTransition>
              // </TransitionGroup>
            )
          }} />
          <FixedFooter></FixedFooter>
        </HashRouter>
      </div>
    );
  }
}

export default App;
